module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("fegwJ"))).then(() => parcelRequire('Kcf3D'));